import React, { useState } from 'react';
import styled from 'styled-components';

type Tab = 'description' | 'materials';

interface InfoTabsProps {
  description: string;
  materials: string;
}

const Tabs = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.lg};
  border-bottom: 1px solid #eee;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const TabButton = styled.button<{ $active: boolean }>`
  padding: 0 0 ${({ theme }) => theme.spacing.sm};
  font-family: ${({ theme }) => theme.fonts.main};
  font-size: 0.85rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.text : theme.colors.lightText};
  border-bottom: 1px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : 'transparent')};
  margin-bottom: -1px;
  cursor: pointer;
  transition: color ${({ theme }) => theme.transitions.short};

  &:hover {
    color: ${({ theme }) => theme.colors.text};
  }
`;

const Body = styled.div`
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.8;
  white-space: pre-wrap;
`;

const InfoTabs: React.FC<InfoTabsProps> = ({ description, materials }) => {
  const [tab, setTab] = useState<Tab>('description');

  return (
    <div>
      <Tabs role="tablist">
        <TabButton
          type="button"
          role="tab"
          aria-selected={tab === 'description'}
          $active={tab === 'description'}
          onClick={() => setTab('description')}
        >
          Description
        </TabButton>
        <TabButton
          type="button"
          role="tab"
          aria-selected={tab === 'materials'}
          $active={tab === 'materials'}
          onClick={() => setTab('materials')}
        >
          Materials
        </TabButton>
      </Tabs>
      <Body role="tabpanel">{tab === 'description' ? description : materials}</Body>
    </div>
  );
};

export default InfoTabs;
